import { createRoute } from '@tanstack/react-router';
import { Shell } from '../components/layout/Shell';
import { HealthDashboard } from '../components/health/HealthDashboard';
import { useHealthSummary } from '../hooks/useHealth';
import { useTranslation } from '../i18n';
import { Route as rootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/health',
  component: HealthPage,
});

function HealthPage() {
  const { data, isLoading } = useHealthSummary();
  const { t } = useTranslation();

  return (
    <Shell>
      <div style={{ maxWidth: '1200px' }}>
        <h1 style={{ fontSize: '1.25rem', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '1.5rem' }}>
          {t('health.title')}
        </h1>

        {isLoading ? (
          <div>{t('health.loadingHealth')}</div>
        ) : !data ? (
          <div style={{ color: 'var(--text-muted)' }}>{t('health.noData')}</div>
        ) : (
          <HealthDashboard data={data} />
        )}
      </div>
    </Shell>
  );
}
